module.exports = __webpack_public_path__ + "img/taptab-logo.b8fab554.png";